var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCloudSun(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame 1000004699"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    d: "M32.9692 20.2304C32.9692 22.7864 31.819 25.0868 30.1576 26.7482C29.3908 25.7258 28.1127 25.0868 26.5791 25.0868C27.3459 20.9972 23.1285 17.8021 19.5501 19.7191C18.9111 17.9299 17.6331 16.3963 15.9717 15.6295C17.5053 12.9457 20.4447 11.1565 23.8953 11.1565C28.8795 11.1565 32.9692 15.1183 32.9692 20.2304Z",
    fill: "url(#paint0_linear_312_3434)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>_2",
    d: "M23.8974 9.11203C23.2584 9.11203 22.875 8.60083 22.875 8.08963V5.02241C22.875 4.5112 23.2584 4 23.8974 4C24.4086 4 24.9198 4.5112 24.9198 5.02241V8.08963C24.9198 8.60083 24.4086 9.11203 23.8974 9.11203Z",
    fill: "url(#paint1_linear_312_3434)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>_3",
    d: "M38.9773 21.2528H35.9101C35.3989 21.2528 34.8877 20.7416 34.8877 20.2304C34.8877 19.5914 35.3989 19.208 35.9101 19.208H38.9773C39.4885 19.208 39.9997 19.5914 39.9997 20.2304C39.9997 20.7416 39.4885 21.2528 38.9773 21.2528Z",
    fill: "url(#paint2_linear_312_3434)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>_4",
    d: "M32.4596 12.6908C31.5649 12.6908 31.0537 11.5406 31.6927 10.9016L33.8654 8.72896C34.2488 8.34556 34.8878 8.34556 35.2712 8.72896C35.6546 9.11236 35.6546 9.75137 35.2712 10.2626L33.0986 12.3074C32.9282 12.563 32.7152 12.6908 32.4596 12.6908Z",
    fill: "url(#paint3_linear_312_3434)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>_5",
    d: "M34.5054 31.8599C34.2498 31.8599 34.0368 31.7747 33.8664 31.6043L31.6938 29.4316C31.3104 29.0482 31.3104 28.4092 31.6938 28.0258C32.0772 27.6424 32.7162 27.6424 33.0996 28.0258L35.2722 30.1985C35.9113 30.8375 35.4 31.8599 34.5054 31.8599Z",
    fill: "url(#paint4_linear_312_3434)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>_6",
    d: "M15.3344 12.6908C15.0788 12.6908 14.8232 12.563 14.5676 12.3074L12.395 10.2626C12.0116 9.75137 12.0116 9.11236 12.395 8.72896C12.9062 8.34556 13.5452 8.34556 13.9286 8.72896L15.9734 10.9016C16.6124 11.5406 16.229 12.6908 15.3344 12.6908Z",
    fill: "url(#paint5_linear_312_3434)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "<Path>_7",
    d: "M25.049 27.0027C25.8158 22.913 21.5983 19.718 17.8921 21.5072C17.1253 18.9512 14.6971 17.0342 11.7577 17.0342C8.05143 17.0342 5.11201 20.2292 5.36761 24.0632C2.30039 24.191 0 26.747 0 29.9421C0 33.1371 2.55602 35.8209 5.87885 35.8209H25.049C27.4772 35.8209 29.522 33.7761 29.522 31.3479C29.522 29.0475 27.7328 27.0027 25.049 27.0027Z",
    fill: "url(#paint6_linear_312_3434)"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_312_3434",
    x1: 15.7352,
    y1: -2.61149,
    x2: 41.0118,
    y2: 19.2027,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAB300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F6DB00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_312_3434",
    x1: 21.0295,
    y1: -3.80735,
    x2: 45.0802,
    y2: 16.9491,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAB300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F6DB00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_312_3434",
    x1: 14.1405,
    y1: -1.299,
    x2: 37.8848,
    y2: 19.1924,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAB300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F6DB00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_312_3434",
    x1: 1.14562,
    y1: -21.202,
    x2: 53.285,
    y2: 23.7952,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAB300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F6DB00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_312_3434",
    x1: 9.07294,
    y1: 4.87215,
    x2: 32.2685,
    y2: 24.8914,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAB300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F6DB00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_312_3434",
    x1: 13.7599,
    y1: 6.28285,
    x2: 36.952,
    y2: 26.2978,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAB300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F6DB00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_312_3434",
    x1: -0.0626224,
    y1: 17.0188,
    x2: 29.5233,
    y2: 17.0188,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#437AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#67A4FE"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloudSun);
export default __webpack_public_path__ + "static/media/cloudSun.40151c18a999af618b401cd12dcd9e9c.svg";
export { ForwardRef as ReactComponent };